import React from 'react';
import { Button, Col, Row } from 'antd';
import CButton from '../../../../Assets/Components/CButton';
import CIcon from '../../../../Assets/Components/CIcon';
import Select from '../../../../Assets/Components/Select';
import Table from '../../../../Assets/Components/CTable';
import { filterStatus } from '../../../../App/Enums';

interface IProps {
  submodule: any;
  columnData: any;
  isLoading: boolean;
  handleAdd: () => void;
  handleRefresh: () => void;
  renderRowSubComponent: any;
  handleApplyfilter: () => void;
  setSelectedStatus: React.Dispatch<React.SetStateAction<any>>;
  selectedStatus?: string;
}

export default function SubmoduleComponent(props: IProps) {
  const {
    columnData,
    submodule,
    selectedStatus,
    handleRefresh,
    handleAdd,
    isLoading,
    renderRowSubComponent,
    setSelectedStatus,
    handleApplyfilter,
  } = props;

  const buttonData = [
    {
      type: 'primary',
      onClick: handleAdd,
      content: 'Tambah Baru',
      id: 'btnModalAddNewChannel',
      className: 'spacingBtnSecondRow2 btnRadius10',
    },
    {
      type: 'ghost',
      content: 'Refresh',
      icon: 'ReloadOutlined',
      id: 'btnRefreshChannelList',
      className: 'btnRadius10',
      onClick: handleRefresh,
    },
  ];
  return (
    <div className="containerWhiteZurich">
      <Row gutter={5}>
        <Col span={4}>
          <label className="labelBtnFilter">Status</label>
          <Select
            dataOption={filterStatus || []}
            idComponent="filterChannel"
            meta={{ touched: false, error: false }}
            input={{
              onBlur: null,
              onChange: setSelectedStatus,
              value: selectedStatus ? selectedStatus : 'Semua',
            }}
            defaultItemName="Semua"
          />
        </Col>
        <Col span={4}>
          <Button
            type="primary"
            icon={<CIcon type="SearchOutlined" />}
            onClick={handleApplyfilter}
            loading={isLoading}
            id="btnSearch"
            className="btnRadius10 marginTop22"
          >
            Cari
          </Button>
        </Col>
        <Col span={16} className={'btnFilterAplicationList'}>
          <CButton
            buttonData={buttonData}
            buttonFloat={'right'}
            isLoading={isLoading}
          />
        </Col>
      </Row>
      <Table
        columns={columnData}
        pagination={true}
        data={submodule || []}
        useFilterGlobal
        renderRowSubComponent={renderRowSubComponent}
        isLoading={isLoading}
      />
    </div>
  );
}
